var exports = {
  "kL": "xb99ab02a--8cfe1a--container",
  "nV": "xb99ab02a--8cfe1a--gallery",
  "wm": "xb99ab02a--8cfe1a--logo",
  "Qs": "xb99ab02a--8cfe1a--content",
  "pq": "xb99ab02a--8cfe1a--info",
  "dt": "xb99ab02a--8cfe1a--projects",
  "DT": "xb99ab02a--8cfe1a--materials",
  "WD": "xb99ab02a--8cfe1a--labels",
  "lZ": "xb99ab02a--8cfe1a--phone",
  "UU": "xb99ab02a--8cfe1a--name",
};

module.exports = exports;
